import { Avatar } from "@faire/slate/components/avatar";
import { Action } from "@faire/slate/foundation/color";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";

const AVATAR_LIST = [
  "https://cdn.faire.com/fastly/2303a7cbd7b6d6a14491d215ae40db0a5d35c6b033f35a30dca5fd875e591176.png",
  "https://cdn.faire.com/fastly/68feea779f953222c7d571af160ea2f0135d4f106220ebbac8484e5c3f934acb.png",
  "https://cdn.faire.com/fastly/b16b5bec3c42f3914089c3d89f5c5063857b2a2f6f8ffccd59ebd27701207464.png",
];

export const Facepiles: React.FC = () => {
  return (
    <Row align="center">
      {AVATAR_LIST.map((avatar, index) => (
        <div key={index} className={index > 0 ? "-ml-2" : ""}>
          <Avatar
            borderColor={Action.border.inverse}
            image={IImage.build({
              url: avatar,
            })}
            size="xSmall"
          />
        </div>
      ))}
      <Spacer size="1x" />
      <Typography variant="paragraphSansMedium">
        <StrictLocalMsg
          id="vxM8Cg"
          defaultMessage="Join the 500K+ retailers on Faire"
          description={{
            text: "Sign up modal subtitle with facepiles",
            img: "https://cdn.faire.com/fastly/ae887856f91fc5812cfeae9129bb55ee64043d34851c948bb539fe28cce76ac3.png",
          }}
        />
      </Typography>
    </Row>
  );
};
